"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.template1 = void 0;
const common_1 = require("./common");
const useBreakpoints_1 = require("../utils/useBreakpoints");
exports.template1 = {
    container: (theme) => {
        const { searchLabel, searchInput, searchError, localeLabel, localeInput, searchButton, externalLink } = common_1.GRID_AREAS;
        const largeScreenStyles = `
      form > div {
        align-items: center;
        grid-template-columns: auto min-content min-content;
        grid-template-areas:
          "${searchLabel} ${localeLabel} ."
          "${searchInput} ${localeInput} ${searchButton}"
          "${searchError} . ."
          "${externalLink} . .";
      }
    `;
        return `
      font-family: ${theme.sw_font_face};
      background-color: ${theme.sw_color_bg_container};
      padding: ${theme.sw_container_padding_v} ${theme.sw_container_padding_h};
      border-radius: calc(${theme.sw_border_radius} * 2);
      border: solid 1px ${theme.sw_color_border};

      form > div {
        display: grid;
        width: 100%;
        grid-template-columns: auto;
        grid-template-rows: auto;
        grid-template-areas:
          "${searchLabel}"
          "${searchInput}"
          "${searchError}"
          "${localeLabel}"
          "${localeInput}"
          "${searchButton}"
          "${externalLink}";
        }
      }

      &.__cq__[data-breakpoint=md] {
        ${largeScreenStyles}
      }

      &.__mq__{
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }
  `;
    },
    searchLabel: (theme) => {
        const { label } = (0, common_1.sharedTemplateFreeText)(theme);
        return `
      ${label}
    `;
    },
    // searchInput is actually the <div> wrapping the MUI autocomplete component
    searchInput: (theme) => {
        const { input } = (0, common_1.sharedTemplateFreeText)(theme);
        return `
      ${input}
    `;
    },
    localeLabel: (theme) => {
        const { label } = (0, common_1.sharedTemplateLocale)(theme);
        const largeScreenStyles = `
      margin: 0 0 0 ${theme.sw_spacing_large};
    `;
        return `
      ${label}

      margin-top: ${theme.sw_spacing_small};

      // when label is present, remove margin from the localeInput (next sibling)
      +div {
        margin-top: 0;
      }

      .__mq__ & {
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }

      .__cq__[data-breakpoint="md"] & {
        ${largeScreenStyles}
      }
    `;
    },
    // localeInput is actually the <div> wrapping the input
    localeInput: (theme) => {
        const { input } = (0, common_1.sharedTemplateLocale)(theme);
        const largeScreenStyles = `
      margin: 0 0 0 ${theme.sw_spacing_large};
    `;
        return `
      ${input}
      min-width: 200px;
      // spacing between localeInput and searchInput when no label, reset above
      margin-top: ${theme.sw_spacing_small};

      .__mq__ & {
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }

      .__cq__[data-breakpoint="md"] & {
        ${largeScreenStyles}
      }
    `;
    },
    button: (theme) => {
        const shared = (0, common_1.sharedTemplateButton)(theme);
        const largeScreenStyles = `
      margin: 0 0 0 ${theme.sw_spacing_large};
      button {
        width: auto;
      }
    `;
        return `
      ${shared}
      
      margin-top: ${theme.sw_spacing_small};

      button {
        border-radius: calc(${theme.sw_border_radius_button} * 2);
        padding: ${theme.sw_spacing_small} ${theme.sw_spacing_xlarge};
        width: 100%;
      }

      .__mq__ & {
        @media (min-width: ${useBreakpoints_1.BREAKPOINTS.md}px) {
          ${largeScreenStyles}
        }
      }

      .__cq__[data-breakpoint="md"] & {
        ${largeScreenStyles}
      }

    `;
    },
    autoComplete: (theme) => {
        const { listItem, popper, chip, chipContainer, groupHeading } = (0, common_1.sharedTemplateAutoComplete)(theme);
        return {
            listItem: `
      ${listItem}
    `,
            popper: `
      ${popper}
    `,
            chip: `
      ${chip}
    `,
            chipContainer: `
      ${chipContainer}
    `,
            groupHeading: `
      ${groupHeading}
    `
        };
    },
    extLink: (theme) => (0, common_1.sharedTemplateExtLink)(theme),
    emptySearchError: (theme) => (0, common_1.sharedTemplateEmptySearchError)(theme)
};
//# sourceMappingURL=template1.js.map